import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { JobsApi } from "@/openapi/generated";

export async function prefetchJobsGet(
  queryClient: QueryClient,
  accessToken: string,
) {
  const service = createAuthenticatedApi(JobsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Jobs],
    queryFn: () => service.apiJobsGet({}),
  });

  return queryClient;
}
